export enum LocationAttentionLevel {
  Green = 'Green',
  Yellow = 'Yellow',
  Red = 'Red'
}
